import React, { useState } from "react";
import { useAuth } from "../../../../hooks";

// Importamos el grid para usuarios free
import { UserFreeGridCmp } from "../../../../components/Admin/UserFreeCmp/UserFreeGridCmp";

import "./Page_UserFreeSalas.scss";

export function Page_UserFreeSalas() {
  const { user, accessToken } = useAuth();
  
  // Inicializamos page y totalPages (totalPages se actualizará en el listado)
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reload, setReload] = useState(false);

  const onReload = () => setReload((prevState) => !prevState);

  return (
    <div className="userfree-salas-page">
      <UserFreeGridCmp
        user={user}
        accessToken={accessToken}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        reload={reload}
        onReload={onReload}
      />
    </div>
  );
}
